import { createSlice } from "@reduxjs/toolkit";
import {
  getAllMakes,
} from "./makeService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  makeList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const makeSlice = createSlice({
  name: "make",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Make List ---------- */
    builder
      .addCase(getAllMakes.pending, (state) => {
        state.makeList.status = STATUS.LOADING;
        state.makeList.error = null;
      })
      .addCase(getAllMakes.fulfilled, (state, action) => {
        state.makeList.status = STATUS.SUCCEEDED;
        state.makeList.data = action?.payload?.data || [];
      })
      .addCase(getAllMakes.rejected, (state, action) => {
        state.makeList.status = STATUS.FAILED;
        state.makeList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectMakeList = (state) =>
  state.make.makeList;

export default makeSlice.reducer;
